import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe } from './filter';
import { LineBreakPipe } from './line-break';
import { SentenceCasePipe } from './sentence-case';

@NgModule({
  declarations: [FilterPipe, LineBreakPipe, SentenceCasePipe],
  imports: [
    CommonModule
  ],
  exports: [FilterPipe, LineBreakPipe, SentenceCasePipe]
})
export class PipesModule { }